import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: "Segoe UI Light", "Segoe UI", sans-serif;
    font-weight: 300; /* Light font */
    background-color: #f4f4f4;
  }

  h2 {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 15px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 20px 0;

    th, td {
      padding: 10px;
      border: 1px solid #ddd;
      text-align: left;
    }

    th {
      background-color: #f5f5f5;
    }
  }

  input, select {
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    width: 150px;
  }

  p, a, div, label {
    font-family: 'Segoe UI Light', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  }
`;

export default GlobalStyle;
